import clientMiddleware from './middleware/client';
import thunkMiddleware from './middleware/thunk';

module.exports = [
  clientMiddleware,
  thunkMiddleware
]
